import React, { ReactNode } from 'react';

import { NotionBlock } from '@Models';
import RichText from '../RichText';
import { HeadingVariant, headingVariants, summaryVariants } from './variants';

interface HeadingRendererProps {
  block: NotionBlock;
  level: 1 | 2 | 3;
  defaultColor: string;
  renderChildren: () => ReactNode;
  variant?: HeadingVariant;
}

const HeadingRenderer = ({
  block,
  level,
  defaultColor,
  renderChildren,
  variant = 'documentation',
}: HeadingRendererProps) => {
  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

  // Check if this is a toggleable heading
  const isToggleable = block.content.is_toggleable === true;

  if (isToggleable) {
    return (
      <details>
        <summary className={summaryVariants({ variant, level })}>
          <RichText segments={block.content.rich_content || []} defaultColor={defaultColor} />
        </summary>
        <div className="ml-6 mt-2">{renderChildren()}</div>
      </details>
    );
  }

  return (
    <>
      <HeadingTag className={headingVariants({ variant, level })}>
        <RichText segments={block.content.rich_content || []} defaultColor={defaultColor} />
      </HeadingTag>
      {renderChildren()}
    </>
  );
};

export default HeadingRenderer;
